import type { WorkspaceId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import { getCmdbRestBaseUrl } from './index.tsx';

const getCmdbQueryLanguageUrl = (workspaceId: WorkspaceId) =>
	`${getCmdbRestBaseUrl(workspaceId)}/aql`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/aql/validate
 */
export const getCmdbQueryLanguageValidateUrl = (workspaceId: WorkspaceId) =>
	`${getCmdbQueryLanguageUrl(workspaceId)}/validate`;
